import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid basic_table" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexBootstrap',
  setup(__props) {

const BasicTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/BasicTable.vue"))
const InverseTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/InverseTable.vue"))
const HoverableTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/HoverableTable.vue"))
const PrimaryBackground = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/PrimaryBackground.vue"))
const CaptionTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/CaptionTable.vue"))
const HeadOptions = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/HeadOptions.vue"))
const StripedRow = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/StripedRow.vue"))
const BreckpointSpecific = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/BreckpointSpecific.vue"))
const ResponsiveTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/ResponsiveTable.vue"))
const SizingTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/SizingTable.vue"))
const CustomTable = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/CustomTable.vue"))
const DashedBorder = defineAsyncComponent(() => import("@/components/theme/table/bootstrap/DashedBorder.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BasicTable)),
      _createVNode(_unref(InverseTable)),
      _createVNode(_unref(HoverableTable)),
      _createVNode(_unref(PrimaryBackground)),
      _createVNode(_unref(CaptionTable)),
      _createVNode(_unref(HeadOptions)),
      _createVNode(_unref(StripedRow)),
      _createVNode(_unref(BreckpointSpecific)),
      _createVNode(_unref(ResponsiveTable)),
      _createVNode(_unref(SizingTable)),
      _createVNode(_unref(CustomTable)),
      _createVNode(_unref(DashedBorder))
    ])
  ]))
}
}

})